import { render, staticRenderFns } from "./vx-router-view.vue?vue&type=template&id=3e2a0902&"
import script from "./vx-router-view.vue?vue&type=script&lang=js&"
export * from "./vx-router-view.vue?vue&type=script&lang=js&"
import style0 from "./vx-router-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports